import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/book/EditRawUnitService";
import { ActionTypes } from "../../../actionTypes/screens/admin/book/EditRawUnitActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";
import _ from "lodash";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.book.editrawunit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: searchVO => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, searchVO });

            EditService.loadScreenView(
                searchVO,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response, searchVO));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data, searchVO) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        searchVO
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveRawUnitAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_RAWUNIT_ASYNC, vo });

            EditService.saveRawUnit(
                vo,
                response => {
                    dispatch(Actions.saveRawUnitSuccess(response));
                },
                error => {
                    dispatch(Actions.saveRawUnitFailure(error));
                }
            );
        };
    },

    saveRawUnitSuccess: data => ({
        type: ActionTypes.SAVE_RAWUNIT_SUCCESS,
        parentType: ActionTypes.SAVE_RAWUNIT_ASYNC,
        data
    }),

    saveRawUnitFailure: error => ({
        type: ActionTypes.SAVE_RAWUNIT_FAILURE,
        parentType: ActionTypes.SAVE_RAWUNIT_ASYNC,
        error
    }),

    uploadImageAsync: (file, id) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.UPLOAD_IMAGE_ASYNC, file, id });

            EditService.uploadPhoto(
                file,
                id,
                response => {
                    dispatch(Actions.uploadImageSuccess(response));
                },
                error => {
                    dispatch(Actions.uploadImageFailure(error));
                }
            );
        };
    },

    uploadImageSuccess: data => ({
        type: ActionTypes.UPLOAD_IMAGE_SUCCESS,
        parentType: ActionTypes.UPLOAD_IMAGE_ASYNC,
        postReducer: uploadImageSuccessPostReducer,
        data
    }),

    uploadImageFailure: error => ({
        type: ActionTypes.UPLOAD_IMAGE_FAILURE,
        parentType: ActionTypes.UPLOAD_IMAGE_ASYNC,
        error
    }),

    removeImage: index => ({
        type: ActionTypes.REMOVE_IMAGE,
        index
    }),

};

//
// Initial State
//
const INITIAL_STATE = {
    rawUnit: null,
    imageIndex: [],
    isUpdate: false
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data, searchVO }) => {
    if (searchVO.id) {
        return { ...state,
            rawUnit: {
                id: data.rawUnit.id,
                images: data.rawUnit.images ? JSON.parse(data.rawUnit.images) : [],
                unitId: data.rawUnit.unitId,
                sectionId: data.rawUnit.sectionId,
                status: data.rawUnit.status,
                sectionName: data.rawUnit.sectionName
            }
        };
    } else {
        return { ...state,
            rawUnit: {
                sectionId: data.rawUnit.sectionId,
                sectionName: data.rawUnit.sectionName,
                count: data.rawUnit.count
            }
        };
    }

};

const uploadImageSuccessPostReducer = (state, { data }) => {
    const { virtualPath } = data;
    let images_new = state.rawUnit.images ? _.clone(state.rawUnit.images) : [];
    images_new.push(virtualPath);

    return { ...state, rawUnit: { ...state.rawUnit, images: images_new }, isUpdate: true };
};

const removeImageReducer = (state, { index }) => {
    let images_new = _.clone(state.rawUnit.images);
    images_new.splice(index, 1);
    
    return { ...state, rawUnit: { ...state.rawUnit, images: images_new }, isUpdate: true };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_RAWUNIT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_RAWUNIT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_RAWUNIT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPLOAD_IMAGE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.UPLOAD_IMAGE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.UPLOAD_IMAGE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REMOVE_IMAGE]: removeImageReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
